import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { Row, Col, Button, Select, message } from "antd";
import PosService from "../../../services/PosService";
import SectionList from "./SectionList";
import DraggableTable from "./DraggableTable";

const TableConfiguration = ({ tableData, saveTableConfig }) => {
  const draggedType = useRef(null);
  const sectionZone = useRef(null);
  const [floor, setFloor] = useState(0);
  const [sectionData, setSectionData] = useState([]);
  const [freeTables, setFreeTables] = useState([]);
  const [selectedSectionId, setSelectedSectionId] = useState();

  useEffect(() => {
    setFreeTables(tableData?.sectionData);
    setSelectedSectionId(
      tableData?.sectionData?.length > 0 ? tableData?.sectionData[0].id : 0
    );
    setFloor(
      tableData?.sectionData?.length > 0 ? tableData?.sectionData[0].floor : 0
    );
    setSectionData(
      tableData?.sectionData?.length > 0
        ? tableData?.sectionData[0].sectionsMap
        : 0
    );
  }, [tableData]);

  const saveMapping = async () => {
    const saveMap = freeTables.map((item) => {
      const sectionsMap = item.sectionsMap
        .filter((itemundefined) => itemundefined != undefined)
        .map((itemMap) => {
          const obj = {
            sections: itemMap.sections
              .filter((itemundefinedSec) => itemundefinedSec != undefined)
              .map((itemSection) => {
                const newObj = {
                  table_number: itemSection.table_number,
                  table_type_id: itemSection.id,
                  server_employee_id: null,
                  host_employee_id: null,
                  section_id: itemMap.id,
                  is_occupied: false,
                };
                return newObj;
              }),
          };

          return obj;
        });

      return sectionsMap;
    });

    const newmap = [].concat(...saveMap);
    const updated = [].concat(...newmap);
    const savedMapArray = [].concat(...updated.map((item) => item.sections));
    if(savedMapArray?.length>0)
    saveTableConfig(savedMapArray);
    else
    message.error("Please configure by drag and drop cells into the sections")
  };

  const deleteCell =(itemDelete)=> {

    const updated = sectionData.map((item) => {
      
        const obj = {
          id: item.id,
          sections: item.sections?.filter(sections=> sections.table_number != itemDelete.table_number),
        };
        return obj;
      
    });

    setSectionData(updated);
  }

  const updateSection = (id, sectionTables, selectedId) => {
    console.log("ayatt", id);
    const updated = sectionData.map((item) => {
      if (item.id == id) {
        const obj = {
          id: item.id,
          sections: sectionTables,
        };
        return obj;
      } else return item;
    });

    setSectionData(updated);
    const sectionmap = freeTables.map((item) => {
      if (item.id == selectedId) {
        const obj = {
          ...item,
          sectionsMap: updated,
        };
        return obj;
      } else return item;
    });
    setFreeTables(sectionmap);
  };

  return (
    <div
      className="table-management-card table-configure content-container"
      onDragOver={(e) => e.preventDefault()}
      // onDrop={outsideDrop}
    >
      <div className="drag-div">
        <h2 className="table-management-card-title">
          Configure your Restaurant
        </h2>

        <Select
          value={floor}
          style={{
            width: 120,
            float: "right",
          }}
          onChange={(e) => {
            let dataSec = [];
            console.log(e);
            const floornum = freeTables.find(
              (item) => parseInt(item.floor) == parseInt(e)
            );

            setSelectedSectionId(floornum?.id);
            setSectionData(floornum?.sectionsMap);
            setFloor(e);
          }}
          options={tableData?.sectionData?.map((val, index) => {
            return { value: val.floor, label: `Floor ${val.floor}` };
          })}
        />
      </div>

      <div className="drag-div">
        <div className="draggable-floor">
          {tableData?.tableData?.map((item, i) => (
            <DraggableTable text={item} />
          ))}
        </div>
        <h3>Drag and Drop cells into the section</h3>
      </div>

      <Row
        style={{
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
          marginTop: "2rem",
          marginBottom: "2rem",
        }}
      >
        {sectionData &&
          sectionData?.map((item, i) => (
            <SectionList
              sectionItems={item.sections}
              i={i}
              sectionData={sectionData}
              sectionId={item.id}
              key={item.id}
              selectedSectionId={selectedSectionId}
              freeTables={freeTables}
              updateSection={updateSection}
              deleteCell = {deleteCell}
            />
          ))}
      </Row>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          margin: "1rem",
        }}
      >
        <Button
          type="primary"
          className="custom-btn"
          style={{ paddingRight: "3rem", paddingLeft: "3rem" }}
          onClick={saveMapping}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default TableConfiguration;
